import moment from 'moment';

export const stringifyZone = (zone, offset, hiddenLabel) => {
    const ensure2Digits = num => num > 9 ? `${num}` : `0${num}`;

    return `(${offset}${zone.offset < 0 ? '-' : '+'}${ensure2Digits(
        Math.floor(Math.abs(zone.offset)),
    )}:${ensure2Digits(Math.abs((zone.offset % 1) * 60))})${!hiddenLabel ? ` ${zone.label}` : ''}`;
};

export const round15Minutes = value => {
    const now = moment(value);

    if (now.minute() < 15) {
        return now.set({ minute: 15 });
    } else if (now.minute() < 30) {
        return now.set({ minute: 30 });
    } else if (now.minute() < 45) {
        return now.set({ minute: 45 });
    }

    return now.set({
        hour: now.hour() + 1,
        minutes: 0
    });

};

export const sortName = (a, b) => {
    const first = a?.name?.toLowerCase();
    const second = b?.name?.toLowerCase();

    if (first < second) {
        return -1;
    }
    if (first > second) {
        return 1;
    }

    return 0;
};

export const formatPhoneNumber = value => {
    if (value.length <= 3) {
        return `(${value})`;
    }
    let newValue = '';
    let count = 0;


    for (let i = 0; i <= value.length - 1; i++) {
        let item = value[i];

        if (/[0-9]/.test(item)) {
            if (count === 0) {
                item = `(${item}`;
            }

            if (count === 2) {
                item = `${item}) `;
            }

            if (count === 6) {
                item = ` ${item}`;
            }

            if (count === 10) {
                item = ` ${item}`;
            }
            count++;
        }
        newValue += item;
    }

    return newValue;
};

export const goToPage = url => {
    if (!url) {
        return;
    }
    window.location.href = url;
};

export const goToRoom = roomId => {
    if (!roomId) {
        return;
    }
    window.location.href = `/home?room=${roomId}`;
};
export const goToRoomWithToken = (roomId, token) => {
    if (!roomId) {
        return;
    }
    window.location.href = `/home?room=${roomId}&jwt=${token}`;
};

export const isVertical = (width, height) => {
    if (height > width) {
        return true;
    }

    return false;
};
